import { useCallback, useMemo, useState } from 'react';
import { getNextSortState, sortRows } from '../utils/tableSortUtils';

/**
 * Tri client des lignes affichées (comme Excel sur les données en mémoire).
 */
export function useTableSort(rows, columnDefs = {}, { defaultSort = null } = {}) {
  const [sort, setSort] = useState(() => defaultSort ?? { key: null, direction: 'asc' });

  const toggleSort = useCallback((key) => {
    setSort((prev) => getNextSortState(prev, key));
  }, []);

  const sortedRows = useMemo(
    () => (sort.key ? sortRows(rows, sort.key, sort.direction, columnDefs) : rows),
    [rows, sort, columnDefs],
  );

  const getSortIcon = useCallback((key) => {
    if (sort.key !== key) return 'mdi:unfold-more-horizontal';
    return sort.direction === 'asc' ? 'mdi:arrow-up' : 'mdi:arrow-down';
  }, [sort]);

  return {
    sortedRows,
    sort,
    setSort,
    toggleSort,
    getSortIcon,
  };
}

/**
 * État de tri serveur (rechargement API à la demande).
 */
export function useServerTableSort(defaultKey = null, defaultDirection = 'asc') {
  const [sort, setSort] = useState({
    key: defaultKey,
    direction: defaultDirection,
  });

  const toggleSort = useCallback((key) => {
    setSort((prev) => getNextSortState(prev?.key ? prev : { key: defaultKey, direction: defaultDirection }, key));
  }, [defaultDirection, defaultKey]);

  const getSortIcon = useCallback((key) => {
    if (sort.key !== key) return 'mdi:unfold-more-horizontal';
    return sort.direction === 'asc' ? 'mdi:arrow-up' : 'mdi:arrow-down';
  }, [sort]);

  return {
    sort,
    setSort,
    toggleSort,
    getSortIcon,
  };
}
